import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_RESOURCES } from '../../store';
import '../admin.css';

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const DocRow = ({ item, idx, total, onEdit, onDelete, onMove }) => (
  <tr>
    <td style={{ color: '#999', fontSize: '.78rem' }}>{idx + 1}</td>
    <td style={{ fontWeight: 600 }}>{item.title}</td>
    <td style={{ fontSize: '.8rem' }}><a href={item.url} target='_blank' rel='noopener noreferrer' style={{ color: '#2878c4', textDecoration: 'none' }}>PDF Link ↗</a></td>
    <td>
      <div className='adm-order-col'>
        <button className='adm-order-btn' onClick={() => onMove(idx, -1)} disabled={idx === 0}>▲</button>
        <button className='adm-order-btn' onClick={() => onMove(idx, 1)}  disabled={idx === total - 1}>▼</button>
      </div>
    </td>
    <td>
      <div className='adm-actions'>
        <button className='adm-btn adm-btn-outline adm-btn-sm' onClick={() => onEdit(item)}>Edit</button>
        <button className='adm-btn adm-btn-danger  adm-btn-sm' onClick={() => onDelete(item.id)}>Delete</button>
      </div>
    </td>
  </tr>
);

const DbSection = ({ label, items, onSave, showToast }) => {
  const [mode, setMode] = useState(null);
  const [form, setForm] = useState({ id: null, title: '', url: '' });

  const openAdd  = () => { setForm({ id: Date.now(), title: '', url: '' }); setMode('add'); };
  const openEdit = (d) => { setForm({ ...d }); setMode('edit'); };
  const close    = () => setMode(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.url.trim()) return showToast('Title and URL are required.', 'error');
    if (mode === 'add') { onSave([...items, { ...form, id: Date.now() }]); showToast(`${label} doc added!`); }
    else { onSave(items.map(d => d.id === form.id ? { ...form } : d)); showToast('Updated!'); }
    close();
  };

  const del  = (id) => { if (window.confirm('Delete this document?')) { onSave(items.filter(d => d.id !== id)); showToast('Deleted.', 'info'); } };
  const move = (idx, dir) => {
    const list = [...items]; const swap = idx + dir;
    if (swap < 0 || swap >= list.length) return;
    [list[idx], list[swap]] = [list[swap], list[idx]]; onSave(list);
  };

  const field = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <>
      <div className='adm-section-hdr' style={{ marginTop: 8 }}>
        <h3>{label} ({items.length})</h3>
        <button className='adm-btn adm-btn-primary adm-btn-sm' onClick={openAdd}>+ Add</button>
      </div>
      <div className='adm-table-wrap' style={{ marginBottom: 28 }}>
        <table className='adm-table'>
          <thead><tr><th>#</th><th>Title</th><th>URL</th><th>Order</th><th>Actions</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#999', padding: 20 }}>No documents. Add one.</td></tr>}
            {items.map((d, idx) => <DocRow key={d.id} item={d} idx={idx} total={items.length} onEdit={openEdit} onDelete={del} onMove={move} />)}
          </tbody>
        </table>
      </div>

      {mode && (
        <div className='adm-modal-overlay' onClick={e => e.target === e.currentTarget && close()}>
          <div className='adm-modal'>
            <div className='adm-modal-header'>
              <h2 className='adm-modal-title'>{mode === 'add' ? `Add ${label} Document` : 'Edit Document'}</h2>
              <button className='adm-close-btn' onClick={close}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='adm-modal-body'>
                <div className='adm-form'>
                  <div className='adm-form-group'>
                    <label className='adm-label adm-label-req'>Title</label>
                    <input className='adm-input' value={form.title} onChange={field('title')} placeholder='Country - Description' required />
                  </div>
                  <div className='adm-form-group'>
                    <label className='adm-label adm-label-req'>Document URL (PDF)</label>
                    <input className='adm-input' value={form.url} onChange={field('url')} placeholder='https://...' required />
                  </div>
                </div>
              </div>
              <div className='adm-modal-footer'>
                <button type='button' className='adm-btn adm-btn-ghost' onClick={close}>Cancel</button>
                <button type='submit' className='adm-btn adm-btn-primary'>{mode === 'add' ? 'Add' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

const ResourcesAdmin = () => {
  const [tab,   setTab]   = useState('bridges');
  const [res,   setRes]   = useState(() => storeGetOrDefault('resources', DEF_RESOURCES));
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: 'success' }), 3000); };

  const saveSection = (key, list) => {
    const updated = { ...res, [key]: list };
    setRes(updated); storeSet('resources', updated);
  };

  const [railForm, setRailForm] = useState({ ...res.railways });
  const [railMode, setRailMode] = useState(false);

  const saveRailways = (e) => {
    e.preventDefault();
    const updated = { ...res, railways: railForm };
    setRes(updated); storeSet('resources', updated);
    setRailMode(false); showToast('Railways section updated!');
  };

  return (
    <div className='adm-page'>
      <Toast {...toast} />
      <div className='adm-header'>
        <div><h1 className='adm-title'>Resources</h1><p className='adm-subtitle'>Manage downloadable documents across all categories</p></div>
      </div>

      <div className='adm-tabs'>
        {[['bridges','Bridges'],['food','Food & Beverage'],['railways','Railways']].map(([id, label]) => (
          <button key={id} className={`adm-tab${tab === id ? ' active' : ''}`} onClick={() => setTab(id)}>{label}</button>
        ))}
      </div>

      {tab === 'bridges' && (
        <DbSection label='Bridge' items={res.bridges} onSave={list => saveSection('bridges', list)} showToast={showToast} />
      )}
      {tab === 'food' && (
        <DbSection label='Food & Beverage' items={res.food} onSave={list => saveSection('food', list)} showToast={showToast} />
      )}
      {tab === 'railways' && (
        <div>
          <div className='adm-section-hdr'>
            <h3>ZINGA on Railways (single download link)</h3>
            {!railMode && <button className='adm-btn adm-btn-outline adm-btn-sm' onClick={() => setRailMode(true)}>Edit</button>}
          </div>
          {!railMode ? (
            <div className='adm-table-wrap'>
              <table className='adm-table'>
                <tbody>
                  <tr><td style={{ fontWeight: 700, width: 160 }}>Title</td><td>{res.railways.title}</td></tr>
                  <tr><td style={{ fontWeight: 700 }}>Description</td><td>{res.railways.desc}</td></tr>
                  <tr><td style={{ fontWeight: 700 }}>Download URL</td><td><a href={res.railways.url} target='_blank' rel='noopener noreferrer' style={{ color: '#2878c4', textDecoration: 'none' }}>View ↗</a></td></tr>
                </tbody>
              </table>
            </div>
          ) : (
            <form onSubmit={saveRailways} style={{ background: '#fff', border: '1px solid #e8ecf0', borderRadius: 10, padding: 24, maxWidth: 600 }}>
              <div className='adm-form'>
                <div className='adm-form-group'>
                  <label className='adm-label'>Title</label>
                  <input className='adm-input' value={railForm.title} onChange={e => setRailForm(f => ({ ...f, title: e.target.value }))} />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Description</label>
                  <textarea className='adm-input adm-textarea' value={railForm.desc} onChange={e => setRailForm(f => ({ ...f, desc: e.target.value }))} />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Download URL</label>
                  <input className='adm-input' value={railForm.url} onChange={e => setRailForm(f => ({ ...f, url: e.target.value }))} />
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button type='button' className='adm-btn adm-btn-ghost' onClick={() => setRailMode(false)}>Cancel</button>
                  <button type='submit' className='adm-btn adm-btn-primary'>Save</button>
                </div>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ResourcesAdmin;
